import dynamic from 'next/dynamic';

// Dynamic import for PartnerBanks - disable SSR to prevent hydration issues
// The child components (PaginatedBankPartners, BankPartnerGallery) use client-side state and SVG icons
const PartnerBanks = dynamic(
  () =>
    import('components/PartnerBanks/PartnerBanks').then((m) => m.PartnerBanks),
  { ssr: false },
);

/**
 * This component is a placeholder for the PartnerBanks component to be able to link it via Contentful.
 */
export function PartnerBanksLink() {
  return <PartnerBanks />;
}
